import React, { useState } from 'react';
import IconCheck from "../../../../assets/images/icon/checkmark_p500.svg";
import { ReactComponent as IconDown } from "../../../../assets/images/icon/ic-chevron-down.svg";
import { ReactComponent as IconUp } from "../../../../assets/images/icon/ic-chevron-up.svg";
import './notificationArccodion.scss';

type Props = {
  isOpen:boolean;
  title:string;
  useArccodion?:boolean; //아코디언(화살표) 기능 사용
  children:React.ReactNode;
  className?: string;
}
const NotificationArccodion = ({isOpen,title,useArccodion=true,children,className}:Props) => {
  const [showNotice, setShowNotice] = useState(isOpen);

  return (
    <div className={`notice-arccodion-wrap ${className}`}>
      <div>
        <p>
          <img src={IconCheck} alt=''/>
          <span className="bold">{title}</span>
        </p>
        {useArccodion &&   
        <>
          {showNotice ? 
            <IconDown onClick={() => setShowNotice(!showNotice)}/>
            :   
            <IconUp className="icon" onClick={() => setShowNotice(!showNotice)}/>
          }
        </>
        }
      </div>
      {showNotice && 
      <div className='notice-content'>
        {children}
      </div>}
    </div>
  );
};

export default NotificationArccodion;